import { FaInstagram } from "react-icons/fa";

export default function AboutUsPage() {
  const coaches = [
    {
      name: "Coach Lim Kai Zhen",
      title: "Head Coach & Squash Specialist",
      intro: [
        "Former Malaysia Squash Player (Kedah)",
        "20+ years of squash experience",
        "Ex-Professional Squash Athlete",
        "Ex-RKC Elite Squash Coach",
        "Asian Squash Federation Coaches Award 2024",
        "Experienced in coaching beginners to competitive players",
        "Specialises in tactics, movement efficiency, and structured training",
        "Passionate about developing strong fundamentals and competitive mindset"
      ],
      img: "/coach_kaizhen.jpg",
      ig: "https://instagram.com/lkz_squash/",
    },
    {
      name: "Coach Lim Ze Dong",
      title: "Assistant Coach • Developer of SquashHub",
      intro: [
        "Former Malaysia Squash Player (Kedah)",
        "20+ years of squash experience",
        "Coached Tsinghua University students (private & group sessions)",
        "Master’s graduate from Tsinghua University (Computer Science)",
        "Developer of SquashHub",
        "Known for patient, structured, and personalised coaching",
        "Experienced in coaching beginners and intermediate players"
      ],
      img: "/coach_zedong.jpeg",
      ig: "https://instagram.com/zd_lim/",
    },
  ];

  return (
    <div className="w-full flex-grow bg-gray-50">
      {/* Hero Section */}
      <div className="bg-green-600 text-white py-16 text-center px-4">
        <h1 className="mb-4">About SquashHub</h1>
        <span className="md:text-base lg:text-lg xl:text-xl">
          Empowering players of all levels with structured coaching, performance tracking,
          and a supportive training environment.
        </span>
      </div>

      {/* Mission Section */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-gray-800 mb-4">Our Mission</h1>
        <span className="md:text-base lg:text-lg xl:text-xl text-gray-600 leading-relaxed">
          SquashHub is built to help players improve smarter, not harder.  
          We combine professional coaching, data-driven performance tracking,
          and personalised training plans to help every athlete reach their full potential.
        </span>
      </div>

      {/* Coaches Section */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-gray-800 mb-8">Meet Our Coaches</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {coaches.map((coach, index) => (
            <div
              key={index}
              className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col min-h-[480px]"
            >
              {/* Image */}
              <img
                src={coach.img}
                alt={coach.name}
                className={`h-80 w-full ${
                    coach.name === "Coach Lim Ze Dong" ? "object-contain" : "object-cover"
                }`}
                style={coach.name === "Coach Lim Ze Dong" ? { objectPosition: "center 15%", padding: '10px' } : {}}
              />

              {/* Info */}
              <div className="p-6 h-full flex flex-col">
                <h1 className="mb-2">{coach.name}</h1>
                <span className="text-green-600 text-md font-medium mb-3">{coach.title}</span>
                <ul className="space-y-2 text-gray-600 md:text-base lg:text-lg leading-relaxed">
                  {coach.intro.map((item, i) => (
                    <li key={i} className="text-left relative pl-5 before:absolute before:left-0 before:top-2 before:w-1 before:h-3 before:bg-green-500 before:rounded">
                      {item}
                    </li>
                  ))}
                </ul>

                {/* Instagram */}
                <div className="flex gap-4 mt-auto pt-4">
                  {coach.ig && (
                    <a
                      href={coach.ig}
                      target="_blank"
                      className="text-red-500"
                    >
                      <FaInstagram size={25} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer Section */}
      <div className="bg-green-50 text-center py-10 px-6">
        <h1 className="text-green-800 mb-2">
          Join Our Squash Community
        </h1>
        <span className="text-gray-600 md:text-base lg:text-lg xl:text-xl">
          Whether you're starting out or preparing for competition,
          SquashHub is here to guide you every step of the way.
        </span>
      </div>
    </div>
  );
}
